import Panel from '@/features/report/shared/Panel/Panel';
import styles from './EditableConclusionsSection.module.css';

interface EditableTagsSectionProps {
  title?: string;
}

export function EditableTagsSection({
  title = 'Tags',
}: EditableTagsSectionProps) {
  return (
    <Panel title={title}>
      <div className={styles.placeholder}>
        Report tag pills will render here.
      </div>
    </Panel>
  );
}
